var ImageChooser = /** @class */ (function () {
    function ImageChooser(html, idPattern) {
        this.html = html;
        this.idPattern = idPattern;
    }
    ImageChooser.prototype.render = function (placeholder, name, id, initialState) {
        var html = this.html.replace(/__NAME__/g, name).replace(/__ID__/g, id);
        // eslint-disable-next-line no-param-reassign
        placeholder.outerHTML = html;
        /* the chooser object returned by createImageChooser also serves as the JS widget representation */
        // eslint-disable-next-line no-undef
        var chooser = createImageChooser(id);
        chooser.setState(initialState);
        return chooser;
    };
    return ImageChooser;
}());
window.telepath.register('wagtail.images.widgets.ImageChooser', ImageChooser);
